export const WebError = {
  en: {
    [200]: 'success', // 成功
    [500]: 'Parameter parsing failed', //  参数解析失败
    [501]: 'Missing signature field', //  签名字段不存在
    [502]: 'Signature verification failed', //  签名失败
    [503]: 'Uid cannot be zero', //  玩家id不能为零
    [504]: 'Cid cannot be zero', //  渠道id不能为零
    [505]: 'Data query failed', //  数据查询失败
    [506]: 'Version cannot be an empty string', //  版本不能为空字符串
    [507]: 'Config does not exist', //  配置文件不存在
    [508]: 'User gift pack does not exist', //  玩家礼包不存在
    [509]: 'Temporarily cannot receive', //  暂时无法领取
    [510]: 'Data update failed', //  数据修改失败
    [511]: 'Data add failed', //  数据增加失败
    [512]: 'country is null', //  国家为空
    [513]: 'Size cannot be zero', //  数据长度不能为零
    [514]: 'Cannot bind yourself', //  不能绑定自己
    [515]: 'Top uid cannot be zero', //  上级玩家id不能为零
    [516]: 'User does not exist', //  玩家不存在
    [517]: 'User already bind', //  玩家已经绑定
    [518]: 'User already receive', //  玩家已经领取
    [519]: 'Type cannot be zero', //  类型不能为零
    [522]: 'Url does not exist',
    [523]: 'Game does not exist',
    [524]: 'Create user failed', // 创建玩家失败
    [525]: ' Rtp upload failed', // RTP上传失败
    [527]: ' RealAmount and Amount are different', // 实际金额和金额不同
    [528]: 'Insufficient Balance', // 余额不足
    [529]: 'Phone cannot be zero', // 手机号不能为零
    [526]: 'AppId or AppSecret invalid', // AppId或AppSecret无效
    [530]: 'This phone number is already in use.Please use a different mobile number.', // 电话号码已绑定
    [531]: 'OTP sending failed OTP', //发送失败
    [532]: 'Verification code cannot be empty', // 验证码不能为零
    [533]: 'The verification code has expired', // 验证码已过期
    [534]: 'Incorrect verification code', // 验证码不正确
    [535]: 'Game score failed', //
    [536]: 'Fb event send fail', //
  },
  tr: {
    [200]: 'success', // 成功
  },
  my: {
    [200]: 'အောင်မြင်မှု​', // 成功
    [500]: 'ပါရာမီတာဖော်ထုတ်ခြင်းမအောင်မြင်ပါ​', //  参数解析失败
    [501]: 'လက်မှတ်အကွက်ပျောက်နေသည်', //  签名字段不存在
    [502]: 'လက်မှတ်အတည်ပြုခြင်းမအောင်မြင်ပါ', //  签名失败
    [503]: 'အသုံးပြုသူ ID သည် သုညမဖြစ်ရပါ', //  玩家id不能为零
    [504]: 'လမ်းကြောင်း ID သည် သုညမဖြစ်ရပါ​', //  渠道id不能为零
    [505]: 'ဒေတာမေးမြန်းခြင်းမအောင်မြင်ပါ​', //  数据查询失败
    [506]: 'ဗားရှင်းသည် ဗလာစာသားမဖြစ်ရပါ​', //  版本不能为空字符串
    [507]: 'config မရှိပါ', //  配置文件不存在
    [508]: 'အသုံးပြုသူလက်ဆောင်အိတ်မရှိပါ', //  玩家礼包不存在
    [509]: 'ယာယီလက်မခံနိုင်ပါ​', //  暂时无法领取
    [510]: 'ဒေတာအသစ်ထည့်သွင်းခြင်းမအောင်မြင်ပါ​', //  数据修改失败
    [511]: 'ဒေတာထည့်သွင်းခြင်းမအောင်မြင်ပါ​', //  数据增加失败
    [512]: 'နိုင်ငံဖြည့်ရမည့်နေရာ အချက်အလက်မရှိသေးပါ', //  国家为空
    [513]: 'အရွယ်အစားသည် သုညမဖြစ်ရပါ​', //  数据长度不能为零
    [514]: 'မိမိကိုယ်ကို ချိတ်ဆက်ခွင့်မရှိပါ​', //  不能绑定自己
    [515]: 'ထိပ်တန်းအသုံးပြုသူ ID သည် သုညမဖြစ်ရပါ​', //  上级玩家id不能为零
    [516]: 'အသုံးပြုသူမရှိပါ​', //  玩家不存在
    [517]: 'အသုံးပြုသူသည် ယခင်ကတည်းက ချိတ်ဆက်ထားပြီးဖြစ်သည်​', //  玩家已经绑定
    [518]: 'အသုံးပြုသူသည် ယခင်ကတည်းက လက်ခံပြီးဖြစ်သည်​', //  玩家已经领取
    [519]: 'အမျိုးအစားသည် သုညမဖြစ်ရပါ​', //  类型不能为零
    [522]: 'URL မရှိပါ​',
    [523]: 'ဂိမ်းမရှိပါ​',
    [524]: 'အသုံးပြုသူဖန်တီးခြင်းမအောင်မြင်ပါ​', // 创建玩家失败
    [525]: 'RTP တင်ခြင်းမအောင်မြင်ပါ​', // RTP上传失败
    [527]: 'RealAmount နှင့် Amount ကွဲလွဲနေသည်​', // 实际金额和金额不同
    [528]: 'လက်ကျန်ငွေမလုံလောက်ပါ​', // 余额不足
    [529]: 'ဖုန်းနံပါတ်သည် သုညမဖြစ်ရပါ​', // 手机号不能为零
    [526]: 'AppId သို့မဟုတ် AppSecret မမှန်ကန်ပါ​', // AppId或AppSecret无效
    [530]: 'အသုံးပြုပြီးဖြစ်သည်။ ကျေးဇူးပြု၍ အခြားဖုန်းနံပါတ်ကို အသုံးပြုပါ။', // 电话号码已绑定
    [531]: 'OTP ပို့ခြင်းမအောင်မြင်ပါ​', //发送失败
    [532]: 'အတည်ပြုကုဒ်သည် ဗလာမဖြစ်ရပါ​', // 验证码不能为零
    [533]: 'အတည်ပြုကုဒ်သက်တမ်းကုန်သွားပြီ​', // 验证码已过期
    [534]: 'အတည်ပြုကုဒ်မှားယွင်းနေသည်​', // 验证码不正确
    [535]: 'ဂိမ်းအချက်ရယူရာတွင် ကျရှုံးခြင်း​​ ', // 游戏得分失败
    [536]: 'Facebook ဖြစ်စဉ် ပြန်လည်ပေးပို့ခြင်း မအောင်မြင်ပါ​', //Fb事件发送失败
  },
  pak: {
    [200]: 'کامیابی', // 成功
    [500]: 'پیرامیٹر تجزیہ ناکام', //  参数解析失败
    [501]: 'لاپتہ دستخط فیلڈ', //  签名字段不存在
    [502]: 'دستخط کی توثیق ناکام ہوئی', //  签名失败
    [503]: 'Uid صفر نہیں ہو سکتا', //  玩家id不能为零
    [504]: 'Cid صفر نہیں ہو سکتا', //  渠道id不能为零
    [505]: 'ڈیٹا سوال ناکام', //  数据查询失败
    [506]: 'ورژن ایک خالی تار نہیں ہو سکتا', //  版本不能为空字符串
    [507]: 'ترتیب موجود نہیں ہے', //  配置文件不存在
    [508]: 'صارف تحفہ پیک موجود نہیں ہے', //  玩家礼包不存在
    [509]: 'عارضی طور پر حاصل نہیں کر سکتے', //  暂时无法领取
    [510]: 'ڈیٹا اپ ڈیٹ ناکام', //  数据修改失败
    [511]: 'ڈیٹا شامل کرنے میں ناکام', //  数据增加失败
    [512]: 'ملک صفر ہے', //  国家为空
    [513]: 'سائز صفر نہیں ہو سکتا', //  数据长度不能为零
    [514]: 'اپنے آپ کو باندھ نہیں سکتا', // 不能绑定自己
    [515]: 'سب سے اوپر uid صفر نہیں ہو سکتا', // 上级玩家id不能为零
    [516]: 'صارف موجود نہیں ہے', // 玩家不存在
    [517]: 'صارف پہلے ہی پابند ہے', // 玩家已经绑定
    [518]: 'صارف پہلے ہی وصول کر چکا ہے', // 玩家已经领取
    [519]: 'قسم صفر نہیں ہو سکتی', // 类型不能为零
    [522]: 'URL موجود نہیں ہے',
    [523]: 'کھیل موجود نہیں ہے',
    [524]: 'صارف بنانے میں ناکام', // 创建玩家失败
    [525]: 'آر ٹی پی اپ لوڈ ناکام', // 上传失败
    [527]: ' حقیقی رقم اور رقم مختلف ہیں', // 实际金额和金额不同
    [528]: 'توازن ناکافی', // 余额不足
    [529]: 'فون صفر نہیں ہو سکتا', // 手机号不能为零
    [526]: 'AppId یا AppSecret غلط', // AppId 或 ایپ سیکریٹ 无效
    [530]: 'یہ فون نمبر پہلے ہی استعمال میں ہے۔ براہ کرم ایک مختلف موبائل نمبر استعمال کریں۔', // 电话号码已绑定
    [531]: 'OTP بھیجنے میں ناکام OTP', //发送失败
    [532]: 'تصدیق کوڈ خالی نہیں ہو سکتا', // 验证码不能为零
    [533]: 'تصدیق کوڈ ختم ہوگیا ہے', // 验证码已过期
    [534]: 'غلط تصدیق کوڈ', // 验证码不正确
    [535]: 'کھیل سکور ناکام', //
    [536]: 'Fb واقعہ بھیجنے میں ناکام', //
  },
}

export function webErrorMsg(code: number, msg?: string) {
  // let value = WebError["en"][code]
  // const lanCode = i18nMgr.getLanguage();
  // if (lanCode != "en") {
  //     let values = WebError[lanCode];
  //     if (values != undefined && values[code] != undefined) {
  //         value = values[code]
  //     }
  // }

  const msg_ = msg || 'Unknown error'
  return msg_
}
